import { render, staticRenderFns } from "./SelfServicePortal.vue?vue&type=template&id=54a93a5d"
import script from "./SelfServicePortal.vue?vue&type=script&lang=js"
export * from "./SelfServicePortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports